import Vue from 'vue'
import Router from 'vue-router'
//直播课堂
import login from '@/components/login'
import index from '@/components/index'
import unIndex from '@/components/unIndex'
import liveStat from '@/components/public/liveStat'
import coursePoints from '@/components/courseMan/coursePoints'
import courseList from '@/components/courseMan/courseList'
import addCourse from '@/components/courseMan/addCourse'
import rment from '@/components/resources/ment'
import rsetup from '@/components/resources/setup'
import iment from '@/components/informa/ment'
import isetup from '@/components/informa/setup'
import declareList from '@/components/declare/list'
import comAudit from '@/components/comAudit/comAudit'
import team from '@/components/resources/team'


Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'login',
			component: login,
			meta: {
				keepAlive: false,//是否缓存
				isBack: true,//是否保存状态
				title: '登录',//title
			}
		},
		{
			path: '/index',
			name: 'index',
			component: index,
			meta: {
				keepAlive: false,//是否缓存
				isBack: true,//是否保存状态
				title: '首页',//title
			},
			children:[
				{
					path: '/unIndex',
					name: 'unIndex',
					component: unIndex,
					meta: {
						keepAlive: true,//是否缓存
						isBack: true,//是否保存状态
						title: '首页',//title
					}
				},
				{
					path: '/comAudit',
					name: 'comAudit',
					component: comAudit,
					meta: {
						keepAlive: true,//是否缓存
						isBack: true,//是否保存状态
						title: '审核管理',//title
					}
				},
				{
					path: '/liveStat',
					name: 'liveStat',
					component: liveStat,
					meta: {
						keepAlive: false,//是否缓存
						isBack: true,//是否保存状态
						title: '直播观看统计',//title
					}
				},
				{
					path: '/school/manage',
					name: 'coursePoints',
					component: coursePoints,
					meta: {
						keepAlive: true,//是否缓存
						isBack: true,//是否保存状态
						title: '学校列表',//title
					}
				},
				{
					path: '/course/list',
					name: 'courseList',
					component: courseList,
					meta: {
						keepAlive: true,//是否缓存
						isBack: true,//是否保存状态
						title: '课程列表',//title
					}
				},
				{
					path: '/addCourse',
					name: 'addCourse',
					component: addCourse,
					meta: {
						keepAlive: false,//是否缓存
						isBack: true,//是否保存状态
						title: '添加优客',//title
					}
				},
				{
					path: '/resources/ment',
					name: 'rment',
					component: rment,
					meta: {
						keepAlive: true,//是否缓存
						isBack: true,//是否保存状态
						title: '资源管理',//title
					}
				},
				{
					path: '/resources/setup',
					name: 'rsetup',
					component: rsetup,
					meta: {
						keepAlive: true,//是否缓存
						isBack: true,//是否保存状态
						title: '资源类型设置',//title
					}
				},
        {
          path: '/resources/team',
          name: 'team',
          component: team,
          meta: {
            keepAlive: true,//是否缓存
            isBack: true,//是否保存状态
            title: '资源类型设置',//title
          }
        },
				{
					path: '/informa/ment',
					name: 'ment',
					component: iment,
					meta: {
						keepAlive: true,//是否缓存
						isBack: true,//是否保存状态
						title: '资讯管理',//title
					}
				},
				{
					path: '/informa/setup',
					name: 'setup',
					component: isetup,
					meta: {
						keepAlive: true,//是否缓存
						isBack: true,//是否保存状态
						title: '资讯类型设置',//title
					}
				},
				{
					path: '/declare/list',
					name: 'declareList',
					component: declareList,
					meta: {
						keepAlive: true,//是否缓存
						isBack: true,//是否保存状态
						title: '申报管理',//title
					}
				},
			]
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if(savedPosition) {
			return savedPosition
		} else {
			if(from.meta.keepAlive) {
				from.meta.savedPosition = document.body.scrollTop
			}
			return {
				x: 0,
				y: to.meta.savedPosition || 0
			}
		}
	},
})



// WEBPACK FOOTER //
// ./src/router/index.js